import styled from 'styled-components';
import { rem } from 'polished';

export const ValueText = styled.span`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(20)};
  color: #000000;
  text-align: center;
`;
